import * as React from 'react';
import Filter from '../../custom/components/filters/filter';
import { FiltersContainerViewProps } from '../../custom/components/filters/container';   

const FiltersListView: React.StatelessComponent<FiltersContainerViewProps> = props => {
    return (
        <>
            <ul className="filters-list" data-accordion-content-id="filters">
                <Filter propertyToFilter="month" filterName={props.text.dateFilterTitleText} noSelectionText={props.text.dateAllSelectionText} />
                <Filter propertyToFilter="eventTypes" filterName={props.text.productionFilterTitleText} noSelectionText={props.text.productionAllSelectionText} />
                <Filter propertyToFilter="accessibilityTypes" filterName={props.text.accessFilterTitle} noSelectionText={props.text.accessAllSelectionText} />
                <Filter propertyToFilter="categories" filterName={props.text.categoryFilterTitleText} noSelectionText={props.text.categoryAllSelectionText} />
                <Filter propertyToFilter="locations" filterName={props.text.venueFilterTitleText} noSelectionText={props.text.venueAllSelectionText} />
            </ul>          
        </>
    )
}

const FiltersContainerView: React.StatelessComponent<FiltersContainerViewProps> = props => {
    return (
            <FiltersListView {...props }></FiltersListView>
    );
}

export default FiltersContainerView;